<div class="modal-header">
  <h4 class="modal-title" id="exampleModalLabel">
    {{ title | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClickCloseModal()"
  ></button>
</div>
<div class="modal-body">
  <div *ngIf="isAdminLoggedIn && !isFranchise && (isMissingStatusData || isMissingRouterData)">
    <span
      class="d-flex text-wrap align-items-baseline"
      [ngClass]="'alert'"
      style="background-color: #FFE899; color: #E56B00; border-radius: 4.45px;"
    >
      <i class="icofont icofont-info-circle"></i>
      <div class="lh-base">
        {{ "warningMessages.missingFranchisedData1" | translate }} {{ " " }} 
        <b> {{ "warningMessages.missingFranchisedData2" | translate }} </b>
      </div>
    </span>
  </div>
  <div class="media media2 justify-content-center align-items-center">
    <button
      *ngFor="let field of saveOption; let i = index"
      type="button"
      [ngStyle]="{ width: 100 / saveOption.length + '%' }"
      [ngClass]="i < saveOption.length - 1 ? 'm-0 p-r-0' : 'm-0'"
      [disabled]="field.disabled"
      style="color: black; border: none; background-color: transparent"
      (click)="onClickOpenModal(field.type)"
    >
      <div class="widget-joins widget-arrow">
        <div class="widget-card modern-card rounded" style="padding: 27px; min-height: 150px" 
          [ngStyle]="
            ((i === 3) && isAdminLoggedIn && !isFranchise && isMissingStatusData) ||
            ((i === 4) && isAdminLoggedIn && !isFranchise && isMissingRouterData)
            ? { 'border-color': '#E8931D', 'border-width': '2px'} 
            : {}"
        >
          <i
            [class]="field.icon"
            class="items-center m-b-10"
            style="font-size: 2rem"
          ></i>
          <h5 class="items-center">{{ field.name | translate }}</h5>
        </div>
      </div>
    </button>
  </div>
</div>
<div 
  class="modal-footer" 
  *ngIf="![
      typeCard.ADMIN_LOCATION_CREATE, 
      typeCard.ADMIN_FRANCHISED_CREATE
    ].includes(type)"
>
  <button class="btn btn-outline-primary" (click)="onClickCloseModal()">
    {{ "buttons.close" | translate }}
  </button>
  <button
    *ngIf="isConfirmButton"
    class="btn btn-primary"
    [disabled]="routerToEdit == null && email == null && advertiser == null"
    (click)="onClickUpdate()"
  >
    {{ "buttons.update" | translate }}
  </button>
</div>
